module.exports = __webpack_public_path__ + "static/media/registerLockGuide1.f058558e.png";